export const CLH_SESSION_ID = crypto.randomUUID();
